import React from 'react'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Icon, IconButton, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  closeButton: {
    height: 'fit-content',
    alignSelf: 'flex-start',
    position: 'absolute',
    right: 0,
    top: 0,
  },
}))

const Toast = () => {
  const classes = useStyles()

  const CloseButton = ({ closeToast }) => (
    <IconButton
      classes={{ root: classes.closeButton }}
      className="Toastify__close-button__position"
      onClick={closeToast}
    >
      <Icon children={'close'} />
    </IconButton>
  )

  return (
    <ToastContainer
      position="top-right"
      autoClose={6000}
      transition={Slide}
      hideProgressBar={false}
      newestOnTop
      closeOnClick={false}
      draggable={false}
      pauseOnHover
      closeButton={<CloseButton />}
      limit={5}
    />
  )
}

export default Toast
